import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import type { Company } from "../../api";
import { SectionTitle } from "../../components";
import { useAuthenticatedSession } from "../../session";
import { EquipeMembres, membresEntreprise } from "../equipe/EquipeMembres";
import { MarqueFormulaires } from "../parametres/MarqueFormulaires";
import styles from "./Esn.module.css";
import { Prelevements } from "../parametres/Prelevements";
import { LimiteCredit } from "./LimiteCredit";
import { ValidationFeuilles } from "./ValidationFeuilles";

/**
 * La fiche d'une entreprise pour l'ESN : son équipe, le circuit de ses
 * feuilles de temps, son paiement et sa marque. Le
 * commercial y fait ce qu'un administrateur de l'entreprise ferait — inviter
 * le premier membre, poser le logo — sans attendre que le client s'en charge.
 */
export function EsnEntreprisePage() {
  const initiale = useOutletContext<Company>();
  const { user, permissions } = useAuthenticatedSession();
  // La fiche mise à jour vit ici jusqu'au prochain rechargement de la
  // coquille : la navigation, elle, relit l'entreprise au changement d'URL.
  const [company, setCompany] = useState(initiale);

  return (
    <div className={styles.fiche}>
      <section aria-labelledby="titre-equipe" className={styles.fiche}>
        <SectionTitle id="titre-equipe">
          Équipe de {company.name}
        </SectionTitle>
        <EquipeMembres
          membres={membresEntreprise(company.id)}
          roles={["admin", "member"]}
          selfUserId={user.id}
          scopeKey={company.id}
        />
      </section>
      <section aria-labelledby="titre-feuilles" className={styles.fiche}>
        <SectionTitle id="titre-feuilles">
          Feuilles de temps
        </SectionTitle>
        <ValidationFeuilles company={company} editable={permissions.can_manage_esn} onUpdated={setCompany} />
      </section>
      <section aria-labelledby="titre-paiement" className={styles.fiche}>
        <SectionTitle id="titre-paiement">
          Paiement
        </SectionTitle>
        <LimiteCredit companyId={company.id} editable={permissions.can_manage_esn} />
        <Prelevements companyId={company.id} />
      </section>
      <section aria-labelledby="titre-marque" className={styles.fiche}>
        <SectionTitle id="titre-marque">
          Marque
        </SectionTitle>
        <MarqueFormulaires company={company} onUpdated={setCompany} />
      </section>
    </div>
  );
}
